import styled from 'styled-components';
import { NotificationsContainer, VIEWPORT_BREAKPOINTS } from '@invent/wl-ui-kit';

const XL_TOAST_MARGIN = '48px';
const L_TOAST_MARGIN = '36px';
const M_TOAST_MARGIN = '32px';
const S_TOAST_MARGIN = '24px';
const TOAST_BOTTOM_MARGIN = '1rem';

export const StyledNotificationsContainer = styled(NotificationsContainer)`
  /* stylelint-disable selector-class-pattern */
  &.Toastify__toast-container--bottom-left,
  &.Toastify__toast-container--top-left {
    bottom: calc(${XL_TOAST_MARGIN} - ${TOAST_BOTTOM_MARGIN});
    left: ${XL_TOAST_MARGIN};

    @media (max-width: ${VIEWPORT_BREAKPOINTS.LARGE}px) {
      bottom: calc(${L_TOAST_MARGIN} - ${TOAST_BOTTOM_MARGIN});
      left: ${L_TOAST_MARGIN};
    }

    @media (max-width: ${VIEWPORT_BREAKPOINTS.MEDIUM}px) {
      bottom: ${M_TOAST_MARGIN};
      left: ${M_TOAST_MARGIN};
    }

    @media (max-width: ${VIEWPORT_BREAKPOINTS.SMALL}px) {
      bottom: ${S_TOAST_MARGIN};
      left: ${S_TOAST_MARGIN};
    }
  }

  @media (max-width: ${VIEWPORT_BREAKPOINTS.MEDIUM}px) {
    width: calc(100vw - ${M_TOAST_MARGIN} * 2);
    padding: 0;

    & .Toastify__toast {
      margin-bottom: 0.5rem;
    }

    & .Toastify__toast:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: ${VIEWPORT_BREAKPOINTS.SMALL}px) {
    width: calc(100vw - ${S_TOAST_MARGIN} * 2);
  }
`;
